(function () {
  if (window.__nestMrcCartMutationGate20260625) return;
  window.__nestMrcCartMutationGate20260625 = true;

  var feeVariantId = 39273096544337;
  var queue = Promise.resolve();
  var cleanupTimer = null;
  var cleanupRunning = false;
  var retryCount = 0;
  var maxRetries = 80;
  var targetMattressHandles = [
    'sparrow-signature-hybrid-mattress',
    'owl-natural-latex-hybrid-mattress',
    'starling-signature-contour-grid',
    'raven-flippable-memory-foam-hybrid-mattress',
    'puffin-memory-foam-kids-mattress'
  ];

  function mark(name, detail) {
    if (window.NestLreCartTiming && typeof window.NestLreCartTiming.mark === 'function') {
      window.NestLreCartTiming.mark(name, detail);
    }
  }

  function currentPath() {
    return window.location && window.location.pathname ? window.location.pathname.toLowerCase() : '';
  }

  function productHandleFromPath() {
    var match = currentPath().match(/^\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function isProductPage() {
    return /^\/products\//.test(currentPath());
  }

  function isMattressDecisionFlowPage() {
    return targetMattressHandles.indexOf(productHandleFromPath()) > -1;
  }

  function isMrcDisabledOnThisPage() {
    return isProductPage() && !isMattressDecisionFlowPage();
  }

  function isFormDataBody(body) {
    return !!(window.FormData && body instanceof FormData);
  }

  function decodedValue(value) {
    try {
      return decodeURIComponent(String(value || '').replace(/\+/g, ' '));
    } catch (error) {
      return String(value || '');
    }
  }

  function bodyToString(body) {
    if (!body) return '';
    if (typeof body === 'string') return body;
    if (body instanceof URLSearchParams) return body.toString();
    if (isFormDataBody(body)) {
      var pairs = [];
      body.forEach(function (value, key) {
        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(String(value)));
      });
      return pairs.join('&');
    }
    if (typeof body === 'object') {
      try { return JSON.stringify(body); } catch (error) { return String(body); }
    }
    return String(body);
  }

  function urlFromFetchArgs(args) {
    var first = args[0];
    if (typeof first === 'string') return first;
    if (first && typeof first.url === 'string') return first.url;
    return '';
  }

  function urlFromAjaxArgs(args) {
    var first = args[0];
    var second = args[1];
    if (typeof first === 'string') return first;
    if (first && typeof first.url === 'string') return first.url;
    if (second && typeof second.url === 'string') return second.url;
    return '';
  }

  function methodFromAjaxArgs(args) {
    var first = args[0];
    var second = args[1];
    if (first && typeof first.type === 'string') return first.type.toUpperCase();
    if (first && typeof first.method === 'string') return first.method.toUpperCase();
    if (second && typeof second.type === 'string') return second.type.toUpperCase();
    if (second && typeof second.method === 'string') return second.method.toUpperCase();
    return 'GET';
  }

  function mrcAmountFromNote(note) {
    var decoded = decodedValue(note);
    var match = decoded.match(/MRC:[^|\s]*-(\d+(?:\.\d+)?)-[A-Z]{2}/i);
    if (!match) return null;
    var amount = Number(match[1]);
    if (!isFinite(amount) || amount <= 0) return null;
    return amount.toFixed(2);
  }

  function normalizeMrcNoteValue(note) {
    var decoded = decodedValue(note);
    var amount = mrcAmountFromNote(decoded);
    if (!amount || !/recycling fee/i.test(decoded)) return note;
    return decoded.replace(/Recycling Fee:\s*\$\s*[\d,.]+/ig, 'Recycling Fee: $' + amount);
  }

  function normalizeMrcNoteUrl(url) {
    if (!url || String(url).indexOf('/cart/update.js') === -1 || String(url).indexOf('note=') === -1) return url;
    try {
      var original = String(url);
      var absolute = new URL(original, window.location.origin);
      var note = absolute.searchParams.get('note');
      var normalized = normalizeMrcNoteValue(note);
      if (note === normalized) return url;
      absolute.searchParams.set('note', normalized);
      mark('MRC note normalized', { from: note, to: normalized });
      return /^https?:\/\//i.test(original) ? absolute.toString() : absolute.pathname + absolute.search + absolute.hash;
    } catch (error) {
      return url;
    }
  }

  function normalizeMrcNoteBody(body) {
    if (!body) return body;
    if (isFormDataBody(body)) {
      if (!body.has('note')) return body;
      var formNote = body.get('note');
      var normalizedFormNote = normalizeMrcNoteValue(formNote);
      if (formNote !== normalizedFormNote) body.set('note', normalizedFormNote);
      return body;
    }
    if (body instanceof URLSearchParams) {
      if (!body.has('note')) return body;
      var paramNote = body.get('note');
      var normalizedParamNote = normalizeMrcNoteValue(paramNote);
      if (paramNote !== normalizedParamNote) body.set('note', normalizedParamNote);
      return body;
    }
    if (typeof body === 'object') {
      if (!Object.prototype.hasOwnProperty.call(body, 'note')) return body;
      var objectNote = body.note;
      var normalizedObjectNote = normalizeMrcNoteValue(objectNote);
      if (objectNote !== normalizedObjectNote) body.note = normalizedObjectNote;
      return body;
    }
    if (typeof body !== 'string' || body.indexOf('note') === -1) return body;
    try {
      var json = JSON.parse(body);
      if (json && Object.prototype.hasOwnProperty.call(json, 'note')) {
        var jsonNote = json.note;
        var normalizedJsonNote = normalizeMrcNoteValue(jsonNote);
        if (jsonNote !== normalizedJsonNote) {
          json.note = normalizedJsonNote;
          return JSON.stringify(json);
        }
      }
    } catch (error) {}
    try {
      var params = new URLSearchParams(body);
      if (params.has('note')) {
        var note = params.get('note');
        var normalized = normalizeMrcNoteValue(note);
        if (note !== normalized) {
          params.set('note', normalized);
          return params.toString();
        }
      }
    } catch (error2) {}
    return body;
  }

  function isMrcFeeUrl(url) {
    return !!url && (url.indexOf(String(feeVariantId)) > -1 || url.indexOf('type%5D=fee') > -1 || url.indexOf('type=fee') > -1);
  }

  function isMrcFeeBody(body) {
    var raw = bodyToString(body);
    if (!raw) return false;
    return raw.indexOf(String(feeVariantId)) > -1 || raw.indexOf('type%5D=fee') > -1 || raw.indexOf('type=fee') > -1 || /\"type\"\s*:\s*\"fee\"/i.test(raw);
  }

  function isMrcNoteValue(value) {
    var noteValue = decodedValue(value);
    return /^MRC:/i.test(noteValue) || /recycling fee/i.test(noteValue);
  }

  function isMrcNoteUrl(url) {
    if (!url || url.indexOf('/cart/update.js') === -1 || url.indexOf('note=') === -1) return false;
    var noteMatch = String(url).match(/[?&]note=([^&]*)/);
    return isMrcNoteValue(noteMatch ? noteMatch[1] : '');
  }

  function isMrcNoteBody(body) {
    if (body && typeof body === 'object' && !isFormDataBody(body)) {
      if (Object.prototype.hasOwnProperty.call(body, 'note')) return isMrcNoteValue(body.note);
    }
    var raw = bodyToString(body);
    if (!raw || raw.indexOf('note') === -1) return false;
    var noteMatch = raw.match(/(?:^|&)note=([^&]*)/);
    if (noteMatch) return isMrcNoteValue(noteMatch[1]);
    try {
      var parsed = JSON.parse(raw);
      if (parsed && Object.prototype.hasOwnProperty.call(parsed, 'note')) return isMrcNoteValue(parsed.note);
    } catch (error) {}
    return false;
  }

  function isCartMutationUrl(url) {
    return !!url && (
      url.indexOf('/cart/update.js') > -1 ||
      url.indexOf('/cart/change.js') > -1 ||
      url.indexOf('/cart/clear.js') > -1 ||
      url.indexOf('/cart/add.js') > -1
    );
  }

  function shouldBypassDisabledMrcMutation(url, body) {
    if (!isMrcDisabledOnThisPage()) return false;
    if (isMrcNoteUrl(url) || isMrcFeeUrl(url)) return true;
    if (url && url.indexOf('/cart/update.js') > -1 && isMrcNoteBody(body)) return true;
    if (url && url.indexOf('/cart/add.js') > -1 && isMrcFeeBody(body)) return true;
    return false;
  }

  function shouldScheduleCleanupForUrl(url) {
    if (isMrcDisabledOnThisPage()) return isMrcFeeUrl(url);
    if (isMattressDecisionFlowPage()) return true;
    return isMrcFeeUrl(url);
  }

  function isQueuedCartMutation(url, body) {
    if (!url) return false;
    if (shouldBypassDisabledMrcMutation(url, body)) return false;
    if (url.indexOf('/cart/update.js') > -1 && (isMrcNoteUrl(url) || isMrcNoteBody(body))) return true;
    if (url.indexOf('/cart/add.js') > -1 && (isMrcFeeUrl(url) || isMrcFeeBody(body))) return true;
    return false;
  }

  function itemTitle(item) {
    return String(item.product_title || item.title || '').toLowerCase();
  }

  function itemProperties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function isMrcFee(item) {
    var props = itemProperties(item);
    return Number(item.variant_id) === feeVariantId ||
      String(props.type || '').toLowerCase() === 'fee' ||
      itemTitle(item).indexOf('mrc recycling fee') > -1 ||
      itemTitle(item).indexOf('mattress recycling fee') > -1;
  }

  function isCompanionItem(item) {
    var title = itemTitle(item);
    return isMrcFee(item) ||
      title.indexOf('lifetime renewal exchange') > -1 ||
      title.indexOf('extend protection') > -1 ||
      title.indexOf('protection plan') > -1;
  }

  function hasPrimaryProduct(cart) {
    return !!(cart && cart.items || []).some(function (item) {
      return Number(item.quantity || 0) > 0 && !isCompanionItem(item);
    });
  }

  function hasMrcFee(cart) {
    return !!(cart && cart.items || []).some(function (item) {
      return Number(item.quantity || 0) > 0 && isMrcFee(item);
    });
  }

  function cleanMrcNote(note) {
    if (!note) return note || '';
    return String(note).split(/\r?\n/).filter(function (line) {
      var lowered = line.toLowerCase();
      return lowered.indexOf('recycling fee') === -1 && lowered.indexOf('mrc') === -1;
    }).join('\n').trim();
  }

  function refreshCartDrawerAfterCleanup() {
    window.setTimeout(function () {
      if (typeof window.UpdateCart === 'function') {
        mark('MRC orphan fee cleanup refresh');
        window.UpdateCart();
      }
    }, 120);
  }

  function removeOrphanFee(cart) {
    var body = { updates: {} };
    body.updates[String(feeVariantId)] = 0;
    var cleanedNote = cleanMrcNote(cart && cart.note);
    if (cart && typeof cart.note === 'string' && cleanedNote !== cart.note) body.note = cleanedNote;
    mark('MRC orphan fee cleanup removing', body);
    return window.fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('MRC cleanup update failed: ' + response.status);
      return response.json();
    }).then(function (updatedCart) {
      mark('MRC orphan fee cleanup complete', { item_count: updatedCart.item_count, total_price: updatedCart.total_price });
      refreshCartDrawerAfterCleanup();
      return updatedCart;
    }).catch(function (error) {
      mark('MRC orphan fee cleanup error', error && error.message ? error.message : String(error));
    });
  }

  function runOrphanCleanup(reason) {
    if (cleanupRunning || !window.fetch) return;
    cleanupRunning = true;
    mark('MRC orphan fee cleanup check', reason || 'scheduled');
    window.fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!hasMrcFee(cart)) return;
        if (hasPrimaryProduct(cart)) {
          mark('MRC orphan fee cleanup skipped', 'primary product still present');
          return;
        }
        return removeOrphanFee(cart);
      })
      .catch(function (error) {
        mark('MRC orphan fee cleanup check error', error && error.message ? error.message : String(error));
      })
      .then(function () { cleanupRunning = false; });
  }

  function scheduleOrphanCleanup(reason, delay) {
    if (cleanupTimer) window.clearTimeout(cleanupTimer);
    cleanupTimer = window.setTimeout(function () {
      cleanupTimer = null;
      queue.catch(function () {}).then(function () { runOrphanCleanup(reason); });
    }, typeof delay === 'number' ? delay : 700);
  }

  function fakeFetchResponse(payload) {
    var body = JSON.stringify(payload || { bypassed: true });
    if (typeof Response === 'function') return Promise.resolve(new Response(body, { status: 200, headers: { 'Content-Type': 'application/json' } }));
    return Promise.resolve({ ok: true, status: 200, json: function () { return Promise.resolve(payload || { bypassed: true }); }, text: function () { return Promise.resolve(body); } });
  }

  function resolvedAjax($, context) {
    if ($ && $.Deferred) {
      var deferred = $.Deferred();
      window.setTimeout(function () { deferred.resolveWith(context || window, [{ bypassed: true }, 'success', null]); }, 0);
      return deferred.promise();
    }
    return Promise.resolve({ bypassed: true });
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__nestMrcCartMutationGate20260703) return;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var url = urlFromFetchArgs(args);
      if (typeof args[0] === 'string') args[0] = normalizeMrcNoteUrl(args[0]);
      if (args[1] && Object.prototype.hasOwnProperty.call(args[1], 'body')) args[1].body = normalizeMrcNoteBody(args[1].body);
      url = urlFromFetchArgs(args);
      var body = args[1] && args[1].body;
      if (shouldBypassDisabledMrcMutation(url, body)) {
        mark('MRC disabled on non-target PDP: fetch bypassed', url || bodyToString(body));
        return fakeFetchResponse({ bypassed: true });
      }
      return originalFetch.apply(this, args).then(function (response) {
        if (isCartMutationUrl(url) && shouldScheduleCleanupForUrl(url)) scheduleOrphanCleanup('after fetch ' + url, 900);
        return response;
      });
    };
    window.fetch.__nestMrcCartMutationGate20260703 = true;
    mark('MRC fetch watcher installed', productHandleFromPath());
  }

  function patchAjax($) {
    if (!$ || !$.ajax || $.ajax.__nestMrcCartMutationGate20260703) return false;
    var originalAjax = $.ajax;
    $.ajax = function () {
      var context = this;
      var args = Array.prototype.slice.call(arguments);
      var options = args[0] && typeof args[0] === 'object' ? args[0] : args[1];
      if (typeof args[0] === 'string') args[0] = normalizeMrcNoteUrl(args[0]);
      if (options && typeof options.url === 'string') options.url = normalizeMrcNoteUrl(options.url);
      if (options && Object.prototype.hasOwnProperty.call(options, 'data')) options.data = normalizeMrcNoteBody(options.data);
      var url = urlFromAjaxArgs(args);
      var method = methodFromAjaxArgs(args);
      var body = options && Object.prototype.hasOwnProperty.call(options, 'data') ? options.data : options;
      if (shouldBypassDisabledMrcMutation(url, body)) {
        mark('MRC disabled on non-target PDP: ajax bypassed', method + ' ' + (url || bodyToString(body)));
        return resolvedAjax($, context);
      }
      if (!isQueuedCartMutation(url, body)) {
        var jqXHR = originalAjax.apply(context, args);
        if (isCartMutationUrl(url) && shouldScheduleCleanupForUrl(url)) {
          jqXHR.always(function () { scheduleOrphanCleanup('after ajax ' + url, 900); });
        }
        return jqXHR;
      }
      var deferred = $.Deferred();
      var label = method + ' ' + url;
      mark('MRC cart mutation queued', label);
      queue = queue.catch(function () {}).then(function () {
        mark('MRC cart mutation start', label);
        return new Promise(function (resolve) {
          var jqXHR = originalAjax.apply(context, args);
          jqXHR.done(function () { deferred.resolveWith(this, arguments); });
          jqXHR.fail(function () { deferred.rejectWith(this, arguments); });
          jqXHR.always(function () {
            mark('MRC cart mutation finish', label);
            if (shouldScheduleCleanupForUrl(url)) scheduleOrphanCleanup('after queued ' + label, 900);
            resolve();
          });
        });
      });
      return deferred.promise();
    };
    $.ajax.__nestMrcCartMutationGate20260703 = true;
    mark('MRC ajax watcher installed', productHandleFromPath());
    return true;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.prototype.__nestMrcCartMutationGate20260703) return;
    var proto = window.XMLHttpRequest.prototype;
    var originalOpen = proto.open;
    var originalSend = proto.send;
    proto.open = function (method, url) {
      var normalizedUrl = normalizeMrcNoteUrl(String(url || ''));
      this.__nestMrcGateRequest20260703 = { method: String(method || 'GET').toUpperCase(), url: normalizedUrl };
      return originalOpen.call(this, method, normalizedUrl);
    };
    proto.send = function (body) {
      var request = this.__nestMrcGateRequest20260703 || {};
      var normalizedBody = normalizeMrcNoteBody(body);
      if (shouldBypassDisabledMrcMutation(request.url, normalizedBody)) {
        mark('MRC disabled on non-target PDP: xhr rewritten', request.method + ' ' + (request.url || bodyToString(normalizedBody)));
        originalOpen.call(this, 'GET', '/cart.js', true);
        return originalSend.call(this, null);
      }
      return originalSend.call(this, normalizedBody);
    };
    proto.__nestMrcCartMutationGate20260703 = true;
    mark('MRC xhr watcher installed', productHandleFromPath());
  }

  function installWhenReady() {
    patchFetch();
    patchXhr();
    if (patchAjax(window.jQuery || window.$)) return;
    retryCount += 1;
    if (retryCount < maxRetries) window.setTimeout(installWhenReady, 50);
  }

  document.addEventListener('click', function (event) {
    if (isMrcDisabledOnThisPage()) return;
    var target = event.target && event.target.closest ? event.target.closest('a, button, input') : null;
    if (!target) return;
    var signal = [target.getAttribute('href'), target.getAttribute('name'), target.getAttribute('aria-label'), target.textContent, target.className].join(' ').toLowerCase();
    if (signal.indexOf('remove') > -1 || signal.indexOf('/cart/change') > -1 || signal.indexOf('quantity') > -1) {
      scheduleOrphanCleanup('after remove or quantity click', 1100);
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (isMrcDisabledOnThisPage()) return;
    var target = event.target;
    if (!target) return;
    var signal = String((target.name || '') + ' ' + (target.className || '')).toLowerCase();
    if (signal.indexOf('quantity') > -1 || signal === 'updates[]') scheduleOrphanCleanup('after quantity change', 1100);
  }, true);

  installWhenReady();

  if (isMrcDisabledOnThisPage()) {
    mark('MRC disabled on non-target PDP', productHandleFromPath());
  } else if (isMattressDecisionFlowPage()) {
    mark('MRC enabled on target mattress PDP', productHandleFromPath());
    scheduleOrphanCleanup('initial target mattress cart check', 1200);
  } else {
    scheduleOrphanCleanup('initial cart check', 1200);
  }
})();